enum FormsImportDialogFields {
	FORMAT = "format",
	FILE = "file",
	FLATTEN = "flatten"
}

export default  FormsImportDialogFields;